import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import { BREAKPOINTS } from '../../src/variables.ts';

((Drupal, once) => {
  'use strict';

  Drupal.behaviors.tpCarousel = {
    attach(context: Document | HTMLElement) {
      const carousels = once('tp-carousel', '.carousel', context);

      carousels.forEach((carousel) => {
        const container = carousel as HTMLElement;
        const swiperContainer = container.querySelector<HTMLElement>('.swiper');
        const prevButton = container.querySelector<HTMLElement>('.carousel__prev');
        const nextButton = container.querySelector<HTMLElement>('.carousel__next');
        const pagination = container.querySelector<HTMLElement>('.carousel__pagination');

        if (!swiperContainer) {
          return;
        }

        new Swiper(swiperContainer, {
          modules: [Navigation, Pagination, A11y],

          // Responsive slides per view matching the React implementation
          slidesPerView: 1,
          spaceBetween: 16,
          breakpoints: {
            [BREAKPOINTS.md]: {
              slidesPerView: 2,
            },
            [BREAKPOINTS.xl]: {
              slidesPerView: 3,
            },
          },

          // Navigation buttons (scoped to this instance)
          navigation: {
            prevEl: prevButton,
            nextEl: nextButton,
          },

          // Pagination bullets
          pagination: {
            el: pagination,
            clickable: true,
            type: 'bullets',
          },

          // Accessibility
          a11y: {
            enabled: true,
            prevSlideMessage: Drupal.t('Previous items'),
            nextSlideMessage: Drupal.t('Next items'),
            paginationBulletMessage: Drupal.t('Go to page {{index}}'),
          },

          // Auto-disable when not enough slides
          watchOverflow: true,

          // Grab cursor for desktop
          grabCursor: true,
        });
      });
    },
  };
})(Drupal, once);
